import React from 'react'
import StudentUserLogin from '../feature/Login/StudentUserLogin'

const StudentUserLoginPage = () => {
  return (
    <StudentUserLogin/>
  )
}

export default StudentUserLoginPage
